import { Switch, Field, Label } from "@headlessui/react";
import { XIcon, CheckIcon } from "@phosphor-icons/react";
import clsx from "clsx";

export function ToggleSwitch({
	enabled,
	setEnabled,
	label,
	displayLabel = true,
}: {
	enabled: boolean;
	setEnabled: React.Dispatch<React.SetStateAction<boolean>>;
	label: string;
	displayLabel?: boolean;
}) {
	return (
		<Field className="yF-flex yF-items-center yF-justify-between yF-gap-2">
			{displayLabel && (
				<Label as="span" className="yF-text-sm hover:yF-cursor-pointer">
					{label.length > 0 ? (
						<span className="yF-font-medium yF-text-gray-900">
							{label}
						</span>
					) : (
						<span className="yF-text-[0.9rem] yF-text-gray-500">
							I understand this has no impact on my credit score
							and agree to the{" "}
							<a
								className="yF-text-[--yF-theme-color] yF-font-semibold"
								href="/privacy-policy"
								target="_blank"
							>
								terms & conditions
							</a>
							.
						</span>
					)}
				</Label>
			)}
			<Switch
				checked={enabled}
				onChange={setEnabled}
				className={clsx(
					enabled ? "" : "yF-bg-gray-200",
					`yF-relative yF-inline-flex yF-h-6 yF-w-11 yF-flex-shrink-0 yF-cursor-pointer yF-rounded-full yF-border-2 yF-border-[--yF-theme-color] yF-transition-colors yF-duration-200 yF-ease-in-out focus:yF-outline-none focus:yF-ring-2 focus:yF-ring-offset-2`
				)}
				style={
					{
						backgroundColor: enabled ? "var(--yF-theme-color)" : "",
						"--tw-ring-color": "var(--yF-theme-color)",
					} as React.CSSProperties
				}
			>
				<span className="yF-sr-only">Use setting</span>
				<span
					className={clsx(
						enabled ? "yF-translate-x-5" : "yF-translate-x-0",
						"yF-pointer-events-none yF-relative yF-inline-block yF-h-5 yF-w-5 yF-transform yF-rounded-full yF-bg-white yF-shadow yF-ring-0 yF-transition yF-duration-200 yF-ease-in-out"
					)}
				>
					<span
						className={clsx(
							enabled
								? "yF-opacity-0 yF-duration-100 yF-ease-out"
								: "yF-opacity-100 yF-duration-200 yF-ease-in",
							"yF-absolute yF-inset-0 yF-flex yF-h-full yF-w-full yF-items-center yF-justify-center yF-transition-opacity"
						)}
						aria-hidden="true"
					>
						<XIcon
							className="yF-h-3 yF-w-3 yF-stroke-[--yF-theme-color] yF-stroke-[10%]"
							size={32}
						/>
					</span>
					<span
						className={clsx(
							enabled
								? "yF-opacity-100 yF-duration-200 yF-ease-in"
								: "yF-opacity-0 yF-duration-100 yF-ease-out",
							"yF-absolute yF-inset-0 yF-flex yF-h-full yF-w-full yF-items-center yF-justify-center yF-transition-opacity"
						)}
						aria-hidden="true"
					>
						<CheckIcon
							className="yF-h-3 yF-w-3 yF-stroke-[--yF-theme-color] yF-stroke-[10%]"
							size={32}
						/>
					</span>
				</span>
			</Switch>
		</Field>
	);
}
